// components/ParallaxSection.js
import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './ParallaxSection.css';

gsap.registerPlugin(ScrollTrigger);

const ParallaxSection = () => {
  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const modelsRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Parallax for model images
      gsap.to('.model-necklace', {
        yPercent: -30,
        xPercent: 20,
        rotation: 5,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom",
          end: "bottom top",
          scrub: 1.5
        }
      });

      gsap.to('.model-ring', {
        yPercent: -50,
        xPercent: -20,
        rotation: -8,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom",
          end: "bottom top",
          scrub: 1.5
        }
      });

      // Text reveal animation
      gsap.from(textRef.current.children, {
        scrollTrigger: {
          trigger: textRef.current,
          start: "top 80%",
          end: "bottom 60%",
          scrub: 1
        },
        opacity: 0,
        y: 50,
        stagger: 0.2
      });

      // Background shimmer effect
      gsap.to('.parallax-bg', {
        backgroundPosition: '100% 0',
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom",
          end: "bottom top",
          scrub: 1
        }
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="parallax-section">
      <div className="parallax-bg"></div>
      
      <div className="parallax-container">
        <div className="models-showcase" ref={modelsRef}>
          <div className="model-item model-necklace">
            <img src="/images/necklace-model-2.png" alt="Necklace on model" />
            <div className="model-overlay">
              <span className="model-category">Eternal Gold</span>
              <h3>The Legacy Necklace</h3>
            </div>
          </div>
          
          <div className="model-item model-ring">
            <img src="/images/ring-model-2.png" alt="Ring on model" />
            <div className="model-overlay">
              <span className="model-category">Diamond Brilliance</span>
              <h3>The Promise Ring</h3>
            </div>
          </div>
        </div>

        <div className="parallax-content" ref={textRef}>
          <span className="section-subtitle">Crafted to be Cherished</span>
          <h2 className="section-title">
            Where Every Piece<br />
            <span className="gold-text">Tells a Story</span>
          </h2>
          <p className="section-description">
            Each creation is a promise of what's next, what shines ahead, 
            what lasts beyond time. Illuminated by the finest diamonds, 
            crafted in hallmarked gold and silver.
          </p>
          
          <div className="craftsmanship-metrics">
            <div className="metric">
              <span className="metric-number">100%</span>
              <span className="metric-label">Hallmarked</span>
            </div>
            <div className="metric">
              <span className="metric-number">Certified</span>
              <span className="metric-label">Natural Diamonds</span>
            </div>
            <div className="metric">
              <span className="metric-number">Custom</span>
              <span className="metric-label">Made Designs</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ParallaxSection;